import React, { FunctionComponent } from 'react';
import { Category } from '../../../../../logic/domains/planProfile.domain';
import {
	Accordion,
	Card,
	Table,
	TableBody,
	TableRow,
	TableCell,
} from '@mlc/web-ui-toolkit';
import { chevronUpSolid, chevronDownSolid } from '@mlc/symbols';
import planProfileTestIds from '../PlanProfile.elements';

type Props = {
	category: Category;
	isOpen: boolean;
	onChange: (idx: number) => void;
};

const PlanCategory: FunctionComponent<Props> = ({
	category,
	isOpen,
	onChange,
}) => (
	<Card marginTop={2}>
		<Accordion
			el="h3"
			title={`${category.name} - ${category.status}`}
			data-id={planProfileTestIds.planCategories}
			isOpen={isOpen}
			onChange={onChange}
			openSymbol={chevronDownSolid}
			closeSymbol={chevronUpSolid}
		>
			<Table layout="fixed" variant="bottomLines">
				<TableBody margin={0}>
					<TableRow>
						<TableCell>Withdrawal value:</TableCell>
						<TableCell data-id={planProfileTestIds.planCategoriesWithdrawalVal}>
							{category.withdrawalValue}
						</TableCell>
					</TableRow>
					<TableRow>
						<TableCell>Fees:</TableCell>
						<TableCell data-id={planProfileTestIds.planCategoriesFeesRuleVal}>
							{category.feesRule}
						</TableCell>
					</TableRow>
					<TableRow>
						<TableCell>Death insurance:</TableCell>
						<TableCell
							data-id={planProfileTestIds.planCategoriesDeathInsuranceVal}
						>
							{category.deathInsurance}
						</TableCell>
					</TableRow>
					<TableRow>
						<TableCell>Total and Permanent Disability Insurance:</TableCell>
						<TableCell
							data-id={planProfileTestIds.planCategoriesTpdInsuranceVal}
						>
							{category.totalAndPermanentDisabilityInsurance}
						</TableCell>
					</TableRow>
					<TableRow>
						<TableCell>Income Protection Insurance:</TableCell>
						<TableCell
							data-id={planProfileTestIds.planCategoriesIncomeProtectionVal}
						>
							{category.incomeProtectionInsurance}
						</TableCell>
					</TableRow>
					<TableRow>
						<TableCell>Members:</TableCell>
						<TableCell data-id={planProfileTestIds.planCategoriesMembersVal}>
							{category.members}
						</TableCell>
					</TableRow>
				</TableBody>
			</Table>
		</Accordion>
	</Card>
);

export default PlanCategory;
